import { useState } from 'react';
import toast from 'react-hot-toast';

import { IconClose } from '../../../common/icons';
import { useModalDialog } from '../../../common/hooks/use-modal-dialog';
import { digitsOnly, groupThousands } from '../../../common/utils/money';
import { useCreatePayment } from '../contexts/accounts';

import '../styles/billing.css';

const today = () => new Date().toLocaleDateString('en-CA');
const METHODS = [{ value: 'cash', label: 'Efectivo' }, { value: 'transfer', label: 'Transferencia' }, { value: 'other', label: 'Otro' }];

function MoneyInput({ value, onChange, disabled }) {
    return (
        <span className="billing-money">
            <span className="billing-money__sign">$</span>
            <input type="text" inputMode="numeric" value={groupThousands(value)} onChange={(e) => onChange(digitsOnly(e.target.value))} disabled={disabled} placeholder="0" />
        </span>
    );
}

// Registrar un pago/abono del dueño (admin-billing-payments.md): reduce lo que debe
// (Debit cash / Credit owner_account). Se abre desde el estado de cuenta del cliente.
export default function PaymentForm({ clientId, clientName, onClose, onSaved }) {
    const { mutateAsync: create, isPending: busy } = useCreatePayment();
    const cardRef = useModalDialog(onClose);
    const [amount, setAmount] = useState('');
    const [date, setDate] = useState(today());
    const [method, setMethod] = useState('transfer');
    const [reference, setReference] = useState('');

    const submit = async () => {
        if (amount === '' || !(Number(amount) > 0)) { toast.error('Ingresá un monto mayor a 0'); return; }
        if (!date) { toast.error('Elegí la fecha'); return; }
        const payload = { owner_client_id: Number(clientId), amount: Number(amount), paid_at: date, method };
        if (reference.trim()) payload.reference = reference.trim();
        try {
            await create(payload);
            toast.success('Pago registrado');
            onSaved?.();
        } catch (er) {
            if (er?.status !== 403) toast.error(er?.message || 'No se pudo registrar el pago');
        }
    };

    return (
        <div className="billing-modal" role="dialog" aria-modal="true" aria-label="Registrar pago">
            <div className="billing-modal__overlay" onClick={onClose} aria-hidden="true" />
            <div className="billing-modal__card" ref={cardRef}>
                <header className="billing-modal__head">
                    <div>
                        <h2 className="billing-modal__title">Registrar pago</h2>
                        <span className="billing-modal__sub">{clientName || `Cliente #${clientId}`}</span>
                    </div>
                    <button type="button" className="billing-modal__close" onClick={onClose} aria-label="Cerrar"><IconClose /></button>
                </header>

                <div className="billing-form">
                    <div className="billing-form__row">
                        <label className="billing-form__field">
                            <span className="billing-form__label">Monto</span>
                            <MoneyInput value={amount} onChange={setAmount} disabled={busy} />
                        </label>
                        <label className="billing-form__field">
                            <span className="billing-form__label">Fecha</span>
                            <input type="date" value={date} max={today()} onChange={(e) => setDate(e.target.value)} disabled={busy} />
                        </label>
                    </div>
                    <div className="billing-form__row">
                        <label className="billing-form__field">
                            <span className="billing-form__label">Medio</span>
                            <select value={method} onChange={(e) => setMethod(e.target.value)} disabled={busy}>
                                {METHODS.map((m) => <option key={m.value} value={m.value}>{m.label}</option>)}
                            </select>
                        </label>
                        <label className="billing-form__field">
                            <span className="billing-form__label">Referencia</span>
                            <input type="text" value={reference} onChange={(e) => setReference(e.target.value)} disabled={busy} placeholder="Opcional" />
                        </label>
                    </div>
                </div>

                <footer className="billing-modal__foot">
                    <button type="button" className="billing-btn billing-btn--ghost" onClick={onClose} disabled={busy}>Cancelar</button>
                    <button type="button" className="billing-btn billing-btn--primary" onClick={submit} disabled={busy || amount === ''}>{busy ? 'Guardando…' : 'Registrar pago'}</button>
                </footer>
            </div>
        </div>
    );
}
